import type { ExcursionRootProps } from "@op/puck-types";
import LayoutRow from "../../../../../components/puck/LayoutRow/LayoutRow";
import { Dc_Excursion_Intro } from "@op/sf-op";
import { HeadingNode } from "../../../../../components/base/HeadingNode";

const ExcursionRoot = ({ title, overline, children }: ExcursionRootProps) => {
  return (
    <div className="w-full mx-auto flex flex-col overflow-auto p-4 rounded-t-[10px]">
      <LayoutRow variant="narrow">
        <Dc_Excursion_Intro
          closeSlot={null}
          overlineSlot={
            (
              <span className="text-caption font-caption text-subtext-color">
                {overline}
              </span>
            ) as unknown as string
          }
          headingSlot={
            (<HeadingNode level={2}>{title}</HeadingNode>) as unknown as string
          }
        />
      </LayoutRow>
      <div className="flex w-full flex-col gap-4">{children}</div>
    </div>
  );
};

export default ExcursionRoot;
